// extracted by mini-css-extract-plugin
module.exports = {"input":"Quotation_input__9qfIW","button":"Quotation_button__2q0jJ","popheader":"Quotation_popheader__2glHa","resumen":"Quotation_resumen__-7DM3"};